// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Returns = (await import('./pages/Returns')).Returns;
    Components.ReturnSummaryPage = (
      await import('./pages/ReturnSummaryPage')
    ).ReturnSummaryPage;
    Components.Home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (
  currentRouteName,
  currentRouteComponent,
  serverPages,
) => ({
  returns: {
    name: 'Returns',
    componentName: 'Returns',
    chunk: () => import('./pages/Returns'),
    get component() {
      return ssr
        ? serverPages.Returns
        : currentRouteName === 'Returns'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Returns,
            })),
          );
    },
    path: '/:context?/myaccount/start-a-return',
    prefetch: [],
    channel: null,
  },
  returnSummary: {
    name: 'ReturnSummaryPage',
    componentName: 'ReturnSummaryPage',
    chunk: () => import('./pages/ReturnSummaryPage'),
    get component() {
      return ssr
        ? serverPages.ReturnSummaryPage
        : currentRouteName === 'ReturnSummaryPage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ReturnSummaryPage,
            })),
          );
    },
    path: '/:context?/myaccount/return-summary',
    prefetch: [],
    channel: null,
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Home })),
          );
    },
    path: '/:context?/',
    channel: null,
  },
});
